import { useMemo, useState } from "react";
import { AlertService } from "../services/Alert";
import { ReportService } from "../services/ReportsService";
import { ChannelUtil } from "../utils/channel";
import { DateUtil } from "../utils/date";
import { MessageUtil } from "../utils/message"

interface MessageType {
    id: number;
    ticketID: string;
    date: Date;
    message: string;
    sendBy: string;
    type: string;
    lng: null;
    lat: null;
    nameSend: string;
    akc: number;
    app: string;
    caption: string;
    chat: string;
    idApp: string;
    user_id: null;
    key_account_client: number;
    duration: null;
    status_call: string;
    standard_formated: boolean;
}

interface TicketType {
    id: string;
    date: Date;
    status: string;
    id_cuenta: number;
    numero_entrada: string;
    numero_salida: string;
    id_usuario: number;
    chat: null;
    categoria: string;
    nota: null;
    _form: string;
    area: string;
    client_id: string;
    fileReport: null;
    label_ticket: null;
    type_send: string;
    date_init: Date;
    date_assignment: Date;
    duration: string;
    base_id: null;
    campaign_id: null;
    campaign_name: string;
    year: string;
    app: string;
    id_extern: null;
    account_client_id: number;
    name_client: string;
    tag_commets: null;
    interaction_client: number;
    origin: string;
}

interface MessageProps {
    ticket: TicketType;
    message: MessageType;
}

function MessageStatus({ akc }) {
    const statusMap = {
        '-99': { icon: "bi-x-circle", color: 'red', text: 'Error desconocido', size: '14px' },
        '-97': { icon: "bi-shield-slash-fill", color: 'red', text: 'Posible SPAM - No enviado', size: '14px' },
        '-98': { icon: "bi-person-x", color: 'red', text: 'Cuenta bloqueada', size: '14px' },
        '-4': { icon: "bi-dash-circle", color: '#f8d053', text: 'Texto invalido', size: '14px' },
        '-3': { icon: "bi-stop-circle", color: 'red', text: 'Sesion de texto libre vencida', size: '14px' },
        '-2': { icon: "bi-question-circle-fill", color: '#ADAAA9', text: 'No registrado en wa', size: '14px' },
        '-1': { icon: "bi-x-circle", color: 'red', text: 'Fallido', size: '14px' },
        '0': { icon: "bi-arrow-clockwise", color: '#f8d053', text: 'Procesando', size: '14px' },
        '1': { icon: "bi-check", color: '#ADAAA9', size: '20px' },
        '2': { icon: "bi-check-all", color: '#ADAAA9', size: '20px' },
        '3': { icon: "bi-check-all", color: '#53bdeb', size: '20px' },
        '5': { icon: "bi-eye-slash", color: '#ADAAA9', text: 'Oculto', size: '16px' }
    };

    const status = statusMap[akc] || { text: 'Estado desconocido' };

    return (
        <span>
            {status.icon && (<i className={`bi ${status.icon}`} style={{ color: status.color, fontSize: status.size }}></i>)}
            {status.text && <span> {status.text}</span>}
        </span>
    );
}


function Message({ ticket, message }: MessageProps) {

    const [imagePreview, setImagePreview] = useState({
        show: false,
        image: null
    })

    const initialsCustomer = useMemo(() => {
        if (!ticket?.name_client) return;

        return ticket.name_client[0].toUpperCase()
    }, [ticket])

    const downloadDocument = async (url) => {
        await AlertService.warning('Descargar archivo', '¿Te gustaría realizar la descarga de este archivo?', async () => {
            try {
                window.open(url, '_blank');
            } catch (error) {
                console.error(error);
                AlertService.error('¡Error!', 'Ocurrió un error al descargar el archivo, intenta nuevamente')
            }
        });
    }


    return (
        <>
            <div className="d-flex mb-5 " >
                <div className={`chat-message-content ${message.sendBy === 'Client' && message.nameSend === 'Client' ? 'received' : ''}`}>
                    <div className={`received-message-content m-w rounded-1 p-3 ${message.sendBy === 'Client' && message.nameSend === 'Client' ? 'border' : 'ms-auto'}`}>
                        {message.sendBy === 'Agent' && message.nameSend !== 'Client' && <div><h6 className="text-white m-0">{message.nameSend}</h6></div>}
                        {message.sendBy === 'Agent' && message.nameSend === 'Client' && <div><h6 className="text-white m-0">🤖 Bot</h6></div>}

                        <div className={`${message.sendBy === 'Client' && message.nameSend === 'Client' ? 'mb-3' : 'my-3'}`}  >
                            {message.type === 'txt' && <div dangerouslySetInnerHTML={{ __html: MessageUtil.format(message.message) }} />}

                            {message.type === 'image' && (
                                <>
                                    {/* <div className="preview-img" onClick={() => downloadDocument(ReportService.getURLExternalFile(message.ticketID, message.message))} style={{ backgroundImage: `url(${ReportService.getURLExternalFile(message.ticketID, message.message)})` }}></div> */}
                                    <div className="preview-img"  >
                                        <img src={ReportService.getURLExternalFile(message.ticketID, message.message)} data-action="zoom" />
                                    </div>
                                    {message.caption && <p className="m-0 mt-2">{message.caption}</p>}
                                </>
                            )}

                            {message.type === 'video' && (
                                <>
                                    <div className="preview-video" ><video controls><source src={ReportService.getURLExternalFile(message.ticketID, message.message)} /></video></div>
                                    {message.caption && <p className="m-0 mt-2">{message.caption}</p>}
                                </>
                            )}

                            {message.type === 'audio' && (
                                <div className="preview-audio d-flex align-items-center" >
                                    <span className="avatar avatar-primary avatar-circle me-2">
                                        <span className="avatar-initials">{initialsCustomer}</span>
                                    </span>
                                    <audio controls><source src={ReportService.getURLExternalFile(message.ticketID, message.message)} /></audio>
                                </div>
                            )}

                            {message.type === 'location' && <div className="" ><iframe width="250" height="250" loading="lazy" allowFullScreen src={ReportService.getURLLocation(message.lat, message.lng)} frameBorder={0} /></div>}

                            {message.type === 'document' && (
                                <div className="d-flex align-items-center preview-document" onClick={() => downloadDocument(ReportService.getURLExternalFile(message.ticketID, message.message))}>
                                    <div className="category-icon"><i className="bi-paperclip"></i></div>
                                    <div className="ms-2">
                                        {message.message}
                                    </div>
                                </div>
                            )}
                        </div>


                        <div><p className="m-0 small italic">{ChannelUtil.format(message.app)}</p></div>
                    </div>
                    <p style={{ color: '#ADAAA9', fontSize: '12px' }} className={`form-text mt-1 ${message.sendBy === 'Client' && message.nameSend === 'Client' ? '' : 'text-end'}`}>{DateUtil.format(message.date)} - <MessageStatus akc={message.akc} />  </p>
                </div>
            </div>
            
        </>
    )
}
export default Message